import { useObserver } from 'mobx-react';
import { useStores } from 'src/js/hook/use-stores';

export const useAuthenticated = () => {
  const { sessionStore } = useStores();
  return useObserver<boolean>(() => sessionStore.authenticated);
};
